var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0C15.672 0 0 15.6759 0 35.0159C0 54.3519 15.672 70.0281 35 70.0281C54.328 70.0281 70 54.3519 70 35.0159C70 15.6759 54.328 0 35 0ZM35 6C50.992 6 64 19.0159 64 35.0159C64 51.0119 50.992 64.0281 35 64.0281C19.012 64.0281 6 51.0119 6 35.0159C6 19.0159 19.012 6 35 6Z",
    fill: "#303634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5193 25.875C35.8203 28.414 37.2226 31.7849 37.2226 35.4849C37.2226 39.1839 35.8203 42.555 33.5153 45.094",
    stroke: "#303634",
    strokeWidth: 6.00129,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4603 17.9771C45.0313 22.4101 47.8711 28.6139 47.8711 35.4849C47.8711 42.3559 45.0313 48.559 40.4603 52.989",
    stroke: "#303634",
    strokeWidth: 6.00129,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 35.907C29 38.633 26.793 40.8398 24.067 40.8398C21.344 40.8398 19.137 38.633 19.137 35.907C19.137 33.18 21.344 30.9729 24.067 30.9729C26.793 30.9729 29 33.18 29 35.907Z",
    fill: "#303634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.c557b81c0eef9caedef54682b2a3a7d7.svg";
export { ForwardRef as ReactComponent };